<template>
  <div class="person-details my-6">
    <div class="container mx-auto px-4">
      <div class="w-full md:flex">
        <div class="sm:w-2/3 md:w-1/4 md:mr-6 mb-4 md:mb-0">
          <img v-if="person.profile_path" class="w-full rounded-md" :src="'https://image.tmdb.org/t/p/w400/' + person.profile_path" alt="{{person.name}}" />
          <img v-else-if="person.gender == 1" class="w-full rounded-md" src="../assets/img/avatar-female.svg" alt="{{person.name}}" />
          <img v-else class="w-full rounded-md" src="../assets/img/avatar-male.svg" alt="{{person.name}}" />
        </div>
        <div class="person-details-body md:w-3/4 p-4 rounded-md">
          <h2 class="mb-2 text-3xl font-semibold">{{ person.name }}</h2>
          <p v-if="person.place_of_birth" class="mb-4 text-sm text-green-500">{{ person.place_of_birth }}</p>
          <p v-if="person.birthday" class="mb-4 text-sm text-green-500">{{ person.birthday }}</p>

          <p v-if="person.biography" class="person-biography mb-4 text-sm text-justify"><span class="font-semibold">Biography: </span>{{ person.biography }}</p>

          <!-- Person Movie Credits -->
          <div v-if="personMovies.length">
            <h4 class="w-full my-4 font-semibold">Movies:</h4>
            <div class="grid grid-cols-3 lg:grid-cols-6 gap-2">
              <div v-for="movie in personMovies" :key="movie.id" class="person-movies">
                <router-link :to="{ name: 'MovieDetails', params: { id: movie.id } }">
                  <img v-if="movie.poster_path" class="w-full rounded-md" :src="'https://image.tmdb.org/t/p/w300/' + movie.poster_path" alt="" />
                  <img v-else class="w-full rounded-md" src="../assets/img/no-poster.svg" alt="" />
                  <p class="mt-2 text-sm font-semibold">{{ movie.title }}</p>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Person Profiles -->
          <div v-if="personImagesProfiles.length">
            <h4 class="w-full my-4 font-semibold">Profiles:</h4>
            <div class="person-profiles grid grid-cols-3 sm:grid-cols-6 gap-2">
              <img v-for="image in personImagesProfiles" :key="image.file_path" class="rounded-md" :src="'https://image.tmdb.org/t/p/w300' + image.file_path" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

import axios from "axios";

export default {
  setup(props) {
    const person = ref([]);
    const personImagesProfiles = ref([]);
    const personMovies = ref([]);

    const error = ref(null);

    const route = useRouter();

    const apiBase = "https://api.themoviedb.org/3/person/";
    const apiKey = "?api_key=e38939d40dcf4625737c388e54bc8f1f";
    const uri = apiBase + props.id + apiKey;
    const uriImages = apiBase + props.id + "/images" + apiKey;
    const uriPersonMovies = apiBase + props.id + "/movie_credits" + apiKey;

    const load = async () => {
      try {
        let data = await axios.get(uri).then((res) => {
          person.value = res.data;
        });
        let dataPersonImages = await axios.get(uriImages).then((res) => {
          personImagesProfiles.value = res.data.profiles;
        });
        let dataPersonMovies = await axios.get(uriPersonMovies).then((res) => {
          personMovies.value = res.data.cast;
        });
      } catch (err) {
        error.value = err.message;
      }
    };
    load();

    return { person, personImagesProfiles, personMovies, error };
  },
  props: ["id"],
  name: "personDetails",
  components: {},
};
</script>

<style>
.person-details-body {
  background-color: #0c1020;
}
</style>
